import { RemoteImportPersonsFromAnotherGroup } from 'data/usecases';
import { ImportPersonsFromAnotherGroupUseCaseInterface } from 'domain/usecases';
import { makeApiUrlImportPersonsFromAnotherGroup } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteImportPersonsFromAnotherGroup =
  (): ImportPersonsFromAnotherGroupUseCaseInterface =>
    new RemoteImportPersonsFromAnotherGroup(
      makeApiUrlImportPersonsFromAnotherGroup(),
      makeAxiosHttpClient(),
    );
